export default __webpack_public_path__ + "img/app-page/screen1.a32eae46fd94235f1d9707709c378d05.png";